import React from "react";
import "./Cards.css";

const Cards = () => {
  return (
    <section className="work-section" name="myWork">

      <div className="work-container">

        <div className="work-header">

          <span className="work-eyebrow">
            Selected Work
          </span>

          <h2>
            My Work
          </h2>

          <p>
            3D Animator specializing in previs, postvis,
            and keyframe animation.
          </p>

        </div>


        <div className="work-grid">

          <article className="work-card">

            <div className="work-card-top">

              <span className="work-card-number">
                01
              </span>

              <h3>
                2023 Animation Reel
              </h3>

            </div>


            <div className="video-wrapper">

              <iframe
                src="https://player.vimeo.com/video/790651050?h=522f45cab3&title=0&portrait=0"
                title="2023 Animation Reel"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />

            </div>

          </article>


          <article className="work-card">

            <div className="work-card-top">

              <span className="work-card-number">
                02
              </span>

              <h3>
                2023 Previs / Postvis Reel
              </h3>

            </div>


            <div className="video-wrapper">

              <iframe
                src="https://player.vimeo.com/video/1223736831?h=248d6e24b4"
                title="2023 Previs / Postvis Reel"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                allowFullScreen
              />

            </div>

          </article>

        </div>


        <div className="work-bottom-copy">

          <span>
            Animation
          </span>

          <span>
            Previs
          </span>

          <span>
            Postvis
          </span>

          <span>
            Keyframe
          </span>

        </div>

      </div>

    </section>
  );
};

export default Cards;